import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lookup-user-placeholder-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lookup-user-placeholder-tab.component.html'
})
export class LookupUserPlaceholderTabComponent {
  /** Tab key used to show label in dummy message */
  @Input() tabKey = '';
  /** Optional extra context (e.g. selected application from Transaction History link). */
  @Input() contextLine: string | null = null;
}
